import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MenuItemsLayout, SizePrice, Upsell, UpsellType, OrderableIngredient, PanelItem } from 'ngx-web-api';
import { MenuWrapperService } from '../../core/services/menu-wrapper.service';
import { BreakpointService } from '../../core/services/breakpoint.service';
import { OrderingUtilsService } from 'app/core/services/ordering-utils.service';

@Component({
  selector: 'fts-checkout-upsell-item',
  templateUrl: './checkout-upsell-item.component.html',
  styleUrls: ['./checkout-upsell-item.component.scss'],
})
export class CheckoutUpsellItemComponent implements OnInit {
  @Input()
  upsellItem: Upsell;
  @Input()
  title: string;
  @Input()
  useVerticalLayout: boolean;
  @Input()
  hideDescription: boolean;
  @Output()
  itemAddedToOrder: EventEmitter<string> = new EventEmitter<string>();
  menuItemsLayoutEnum = MenuItemsLayout;

  selectedQuantity = 1;
  selectedSizePrice: SizePrice;

  imageSrc: string;
  panelItem: PanelItem;
  calories?: string;
  upsellType = UpsellType.ORDER_BASED;

  selectedUpfrontIngredient: OrderableIngredient;
  upfrontQualifiers: string[] = [];

  constructor(
    private menuService: MenuWrapperService,
    public breakPointService: BreakpointService,
    private orderingUtilsService: OrderingUtilsService
  ) {}

  ngOnInit() {
    this.orderingUtilsService.itemAddedToOrder$.subscribe(result => {
      if (result === this.upsellItem.orderableItem.item) this.itemAddedToOrder.emit(result);
    });
    this.panelItem = this.menuService.convertUpsellToPanelItem(this.upsellItem);
    this.imageSrc = this.menuService.getPanelItemPictureSrc(this.panelItem);
    this.selectedSizePrice = this.menuService.getDefaultSizePrice(this.panelItem.sizePrices);
    this.calories = this.menuService.getItemCalories(this.selectedSizePrice, this.panelItem.showFullSizeCalories);
  }

  onSizeChange(size: SizePrice): void {
    this.calories = this.menuService.getItemCalories(size, this.panelItem.showFullSizeCalories);
  }

  onIngredientChange(ingredient: OrderableIngredient) {
    this.selectedUpfrontIngredient = ingredient;
  }

  onQualifierChange(qualifer: string[]) {
    this.upfrontQualifiers = qualifer;
  }
}
